// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ListItemLabel-base__gNF1f{display:flex;gap:var(--size-2);align-items:center;width:var(--size-full);min-width:0;max-width:-moz-max-content;max-width:max-content}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ListItemLabel-base__gNF1f"
};
export default ___CSS_LOADER_EXPORT___;
